/**
 * useMealHistory - Meal history browsing state & API calls
 * Extracted from App.js Phase 5 refactoring
 */
import { useState, useCallback } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const useMealHistory = (userTimezone) => {
  const [mealHistory, setMealHistory] = useState([]);
  const [mealHistoryLoading, setMealHistoryLoading] = useState(false);
  const [mealHistoryFilter, setMealHistoryFilter] = useState('all');
  const [mealHistoryDays, setMealHistoryDays] = useState(14);

  const loadMealHistory = useCallback(async (uid, days = 14) => {
    setMealHistoryLoading(true);
    try {
      const response = await fetch(`${BACKEND_URL}/api/meals/${uid}/history?days=${days}&tz_offset=${userTimezone}`);
      if (response.ok) {
        const data = await response.json();
        setMealHistory(data.meals || []);
        if (data.user_local_today) {
          window.__userLocalToday = data.user_local_today;
          console.log('[MealHistory] user_local_today set to:', data.user_local_today);
        } else {
          const tzOffset = userTimezone || Math.round(-new Date().getTimezoneOffset() / 60);
          const localNow = new Date(Date.now() + tzOffset * 3600000);
          window.__userLocalToday = localNow.toISOString().split('T')[0];
          console.log('[MealHistory] user_local_today fallback:', window.__userLocalToday);
        }
        window.__userTimezoneOffset = userTimezone || Math.round(-new Date().getTimezoneOffset() / 60);
      }
    } catch (error) {
      console.error('Error loading meal history:', error);
    } finally {
      setMealHistoryLoading(false);
    }
  }, [userTimezone]);

  return {
    mealHistory,
    setMealHistory,
    mealHistoryLoading,
    mealHistoryFilter,
    setMealHistoryFilter,
    mealHistoryDays,
    setMealHistoryDays,
    loadMealHistory
  };
};

export default useMealHistory;
